import axios from "axios";
import { generateUUID } from "../utils/Functions";
import { baseURL } from "../config";

const MAPS_PROXY_BASE_URL = `${baseURL}/api/v1/maps/places`;

export const searchPlaces = async (query) => {
  if (!query || query.length < 3) return [];

  try {
    const response = await axios.get(`${MAPS_PROXY_BASE_URL}/autocomplete`, {
      params: {
        input: query,
      },
      headers: {
        "X-Request-Id": generateUUID(),
      },
    });

    return response?.data?.data || [];
  } catch (error) {
    console.error("Ola Search Error:", error.response?.data || error.message);
    return [];
  }
};

export const getPlaceDetails = async (placeId) => {
  try {
    const response = await axios.get(`${MAPS_PROXY_BASE_URL}/details`, {
      params: {
        place_id: placeId,
      },
      headers: {
        "X-Request-Id": generateUUID(),
      },
    });

    return response?.data?.data || null;
  } catch (error) {
    console.error("Ola Details Error:", error.response?.data || error.message);
    return null;
  }
};
